import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_LANDING_NAME,
} from '../../../engineering-systems-constants';
import { GalleryListStructure } from '../../../components';

export const FILTER_GALLERY_LIST: GalleryListStructure[] = [
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/1.jpg/1.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-7.jpg/filter-7.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-7.jpg/filter-7.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '7.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/2.jpg/2.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-13.jpg/filter-13.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-13.jpg/filter-13.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '13.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/3.jpg/3.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-3.jpg/filter-3.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-3.jpg/filter-3.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '3.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/4.jpg/4.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-4.jpg/filter-4.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-4.jpg/filter-4.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '4.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/5.jpg/5.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-5.jpg/filter-5.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-5.jpg/filter-5.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '5.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/6.jpg/6.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-6.jpg/filter-6.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-6.jpg/filter-6.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '6.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/7.jpg/7.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-1.jpg/filter-1.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-1.jpg/filter-1.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '1.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/8.jpg/8.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-8.jpg/filter-8.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-8.jpg/filter-8.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '8.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/9.jpg/9.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-9.jpg/filter-9.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-9.jpg/filter-9.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '9.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/10.jpg/10.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-10.jpg/filter-10.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-10.jpg/filter-10.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '10.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/11.jpg/11.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-11.jpg/filter-11.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-11.jpg/filter-11.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '11.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/12.jpg/12.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-12.jpg/filter-12.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-12.jpg/filter-12.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '12.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/13.jpg/13.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-2.jpg/filter-2.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-2.jpg/filter-2.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '2.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/filter/popup/14.jpg/14.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-14.jpg/filter-14.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/filter/filter-14.jpg/filter-14.jpg`,
    alt: 'Пример установки системы фильтрации',
    name: '14.jpg',
  },
];
